import React from 'react';
import { SiteContent } from 'components/common/styles';
import ContentLayout from 'components/ContentLayout';
import Setting from 'components/Admin/Setting';
// eslint-disable-next-line
export default () => {
  return (
    <ContentLayout>
      <SiteContent>
        {/*<h1>Warehouse</h1>*/}
        <Setting />
      </SiteContent>
    </ContentLayout>
  );
};
